(()=>{
  const root=document;
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  let resumeHero=false;
  let resumeVisible=false;
  function hero(){return root.querySelector('.eq-hero-video');}
  function playbackState(){
    const v=hero();if(!v)return;
    const playing=!v.paused&&!v.ended;
    root.querySelectorAll('[data-eq-playback]').forEach(b=>{
      b.setAttribute('aria-pressed',String(playing));
      b.setAttribute('aria-label',playing?b.dataset.eqPauseLabel:b.dataset.eqPlayLabel);
      if(b.dataset.eqFallback!==undefined)b.hidden=playing;
    });
  }
  function playHero(manual=false){
    const v=hero();if(!v||(!manual&&reduced.matches))return;
    v.muted=true;v.defaultMuted=true;v.playsInline=true;
    v.setAttribute('muted','');v.setAttribute('playsinline','');
    v.preload='metadata';
    if(manual)v.dataset.eqUserPlayed='true';
    const attempt=v.play();
    if(attempt&&typeof attempt.catch==='function')attempt.catch(()=>{playbackState();});
  }
  function openDialog(dialog){
    if(!dialog||dialog.open)return;dialog.showModal();
    const v=dialog.querySelector('video');
    if(v&&dialog.id==='eq-film'){const h=hero();resumeHero=!!h&&!h.paused;h?.pause();v.play().catch(()=>{});}
  }
  root.addEventListener('click',event=>{
    const open=event.target.closest('[data-eq-open]');if(open)openDialog(root.getElementById(open.dataset.eqOpen));
    const close=event.target.closest('[data-eq-close]');if(close)close.closest('dialog')?.close();
    const anchor=event.target.closest('dialog a[href^="#"]');if(anchor)anchor.closest('dialog').close();
    const playback=event.target.closest('[data-eq-playback]');
    if(playback){const v=hero();if(v){if(v.paused||v.ended)playHero(true);else{v.pause();playbackState();}}}
  });
  function init(){
    root.querySelectorAll('dialog:not([data-eq-ready])').forEach(dialog=>{
      dialog.dataset.eqReady='true';
      dialog.addEventListener('close',()=>{
        dialog.querySelectorAll('video').forEach(v=>v.pause());
        if(dialog.id==='eq-film'&&resumeHero&&!reduced.matches)playHero();
        resumeHero=false;
        root.querySelector(`[data-eq-open="${dialog.id}"]`)?.focus({preventScroll:true});
      });
      dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();});
    });
    const v=hero();if(!v||v.dataset.eqReady)return;v.dataset.eqReady='true';
    const control=root.querySelector('[data-eq-playback]');
    const actions=root.querySelector('.eq-hero-actions');
    if(control&&actions&&!actions.querySelector('[data-eq-fallback]')){
      const fallback=root.createElement('button');fallback.type='button';
      fallback.className='eq-button eq-button-secondary eq-hero-fallback';
      fallback.dataset.eqPlayback='';fallback.dataset.eqFallback='';
      fallback.dataset.eqPlayLabel=control.dataset.eqPlayLabel;fallback.dataset.eqPauseLabel=control.dataset.eqPauseLabel;
      fallback.textContent=control.dataset.eqPlayLabel;actions.append(fallback);
    }
    const label=root.querySelector('[data-eq-duration]');
    const duration=()=>{if(label&&Number.isFinite(v.duration)){const seconds=Math.round(v.duration);label.textContent=String(Math.floor(seconds/60)).padStart(2,'0')+':'+String(seconds%60).padStart(2,'0');}};
    v.addEventListener('loadedmetadata',duration);v.addEventListener('playing',playbackState);v.addEventListener('play',playbackState);v.addEventListener('pause',playbackState);v.addEventListener('ended',playbackState);v.addEventListener('error',playbackState);
    duration();playbackState();v.autoplay=!reduced.matches;
    if(!reduced.matches)playHero();
  }
  init();
  reduced.addEventListener('change',e=>{const v=hero();if(!v)return;v.autoplay=!e.matches;if(e.matches){v.pause();v.removeAttribute('data-eq-user-played');playbackState();}else playHero();});
  document.addEventListener('visibilitychange',()=>{const v=hero();if(!v)return;if(document.hidden){resumeVisible=!v.paused;v.pause();}else if(resumeVisible&&!reduced.matches&&!root.querySelector('#eq-film[open]')){resumeVisible=false;playHero();}});
  document.addEventListener('shopify:section:load',init);
})();
